import { apolloClient } from '~/apollo-client';
import { LDClient, LDFlags } from '~/providers';
import {
  ContractTag,
  Flex_FetchLmiFormQuery,
  Flex_FetchLmiFormQueryVariables,
} from '~/typings/graphql';
import { FETCH_LMI_FORM } from './fetch-lmi-form.queries';

export const fetchLmiForm = async (params: FetchLmiFormParams): Promise<FetchLmiFormResponse> => {
  const { stateId, contractTags } = params;

  const { data } = await apolloClient.query<
    Flex_FetchLmiFormQuery,
    Flex_FetchLmiFormQueryVariables
  >({
    query: FETCH_LMI_FORM,
    variables: { stateId, tags: contractTags ?? [] },
  });

  const { lmiForm } = data;
  const showLmiFromTerms = !!lmiForm && isSatisfyingDefaultLmiRules(stateId);

  return {
    docuSignContracts: lmiForm ? [lmiForm] : [],
    showLmi: showLmiFromTerms,
  };
};

export const isSatisfyingDefaultLmiRules = (stateId: number) => {
  const lmiSelfAttestationStates = LDClient.variation(LDFlags.lmiSelfAttestationState);
  return lmiSelfAttestationStates.includes(stateId);
};

export type ContractVersion = {
  contractId: number;
  contractType: string;
  displayName: string;
  fileUrl: string;
  id: number;
  scrollRequired: boolean;
  tag?: ContractTag | null;
  contractVersionLanguageId?: number | null;
  signatureType?: string;
};

export type FetchLmiFormParams = {
  stateId: number;
  contractTags?: ContractTag[];
};

export interface FetchLmiFormResponse {
  docuSignContracts: ContractVersion[];
  showLmi?: boolean;
}
